module.exports = __webpack_public_path__ + "static/media/blog-single.b0bb06b9.jpg";